import { DASHBOARD_CONTAINER } from '../../../../types/types';
import { dropdown } from '../../../dropdown';
import AddCustomer from './add-new-customer';

import { INewPartner } from '../../../../models/partner.interface';
import GetPartners from '../../../../routes/get-partners';


/**
 * Handles the AWS api response to get partner data and calls the function
 * to add the new customer.
 * 
 * @returns void
 */
const HandleNewCustomerForm = async () => {
  const { body } = await GetPartners();

  const mapList = body.map((value: INewPartner) => {
    return { id: value.partnerID, name: value.partnerName };
  });
  dropdown(mapList, 'partner', 'Partner', true, true, true);

  DASHBOARD_CONTAINER.removeAttribute('style');

  AddCustomer();
}

export default HandleNewCustomerForm;